import { FC, useEffect, useState } from "react";
import Modal from "../shared/Modal/Modal";
import { useApp, ConnectionSessionErrorId, ConnectionSessionErrorIdType } from "../../context/AppContext";
import styles from "../../assets/css/preview.module.scss";

const ScanErrorMessageModal: FC = () => {
  const { connectionSessionError, updateSessionRef } = useApp();
  const sessionErrorMessageId = connectionSessionError?.id;

  const [isScanErrorMessageModalOpen, setIsScanErrorMessageModalOpen] = useState(false);

  useEffect(() => {
    const {
      CLUTTERED_BACKGROUND,
      BAD_DEPTH_DATA,
      ARCH_HEIGHT_OUT_OF_RANGE,
      RIGHT_LEFT_FOOT_LENGTH_DIFF_OUT_OF_RANGE,
      RIGHT_LEFT_ARCH_HEIGHT_DIFF_OUT_OF_RANGE,
      UNKNOWN,
    } = ConnectionSessionErrorId;
    if (([
      CLUTTERED_BACKGROUND,
      BAD_DEPTH_DATA,
      ARCH_HEIGHT_OUT_OF_RANGE,
      RIGHT_LEFT_FOOT_LENGTH_DIFF_OUT_OF_RANGE,
      RIGHT_LEFT_ARCH_HEIGHT_DIFF_OUT_OF_RANGE,
      UNKNOWN,
    ] as ConnectionSessionErrorIdType[]).includes(sessionErrorMessageId)) {
      setIsScanErrorMessageModalOpen(true);
    } else {
      setIsScanErrorMessageModalOpen(false);
    }
  }, [sessionErrorMessageId]);

  const closeScanErrorMessageModal = () => {
    updateSessionRef({ instruction: "Try again on your mobile device" });
    setIsScanErrorMessageModalOpen(false);
  }

  return (
    <Modal isOpen={isScanErrorMessageModalOpen}>
      <div className={`${styles.genericErrorMessageModal}`}>
        <div className={`${styles.genericErrorMessageModalOverlay}`}></div>
        <div className={`${styles.genericErrorMessageModalDialog}`}>
          <div className={styles.genericErrorMessageModalContent}>
            <div className={styles.genericErrorMessageModalWrapper}>
              <h1 className={styles.genericErrorMessageModalTitle}>We&apos;re Sorry!</h1>
              <div className={styles.genericErrorMessageModalText}>
                There was a problem initializing your scan. Please try
                again on your mobile device.
              </div>

              <div className={styles.genericErrorMessageModalCloseButton}>
                <button className={styles.commonCloseButton} onClick={closeScanErrorMessageModal}></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ScanErrorMessageModal;
